import './App.css';
import React from 'react';
import ReactDOM from 'react-dom/client'; // Neu: Verwende 'react-dom/client' für React 18+
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);